/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/** Header */

const __announcementBarSection__ = document.querySelector('.shopify-section-group-header-group.js-section__announcement');
const __announcementBar__ = __announcementBarSection__.querySelector('.announcement-bar__wrapper[data-sticky-announcement-bar]');

__makeStickyAnnouncementBar__(__announcementBar__, __announcementBarSection__);

function __makeStickyAnnouncementBar__(announcementBar, announcementBarSection) {
    if(announcementBar && announcementBarSection) {
        announcementBarSection?.classList.add('js-section__announcement--sticky');
    } else {
        announcementBarSection?.classList.remove('js-section__announcement--sticky');
    }
}